import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { ModalCloseButton } from '../buttons/ModalCloseButton'
import { PropsWithChildren } from 'react'

export interface ModalProps extends PropsWithChildren {
  onClose?: () => void
  backgroundColor?: string
  disableClose?: boolean
  noPadding?: boolean
  closeButtonVariant?: 'default' | 'light'
  maxWidth?: string
  height?: string
}

export const Modal = ({
  onClose,
  disableClose,
  children,
  backgroundColor = theme.color.white,
  noPadding,
  closeButtonVariant = 'default',
  maxWidth,
  height,
}: ModalProps) => {
  const handleClose = () => {
    if (!onClose || disableClose) {
      return
    }
    onClose()
  }
  return (
    <ModalContainer onClick={handleClose}>
      <ModalDiv
        onClick={(e) => !disableClose && e.stopPropagation()}
        $backgroundColor={backgroundColor}
        $noPadding={noPadding}
        $maxWidth={maxWidth}
        $height={height}
      >
        {!disableClose && <ModalCloseButton onClick={handleClose} variant={closeButtonVariant} />}
        {children}
      </ModalDiv>
    </ModalContainer>
  )
}

export const ModalContainer = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${theme.color.modalBackdrop};
  z-index: 10000;
  align-items: center;
  justify-content: center;
`

const ModalDiv = styled.div<{ $backgroundColor: string; $noPadding?: boolean; $maxWidth?: string; $height?: string }>`
  position: relative;
  background-color: ${({ $backgroundColor }) => `${$backgroundColor}`};
  overflow: scroll;
  padding: ${({ $noPadding }) => ($noPadding ? '0' : `${theme.spacing.large}px`)};
  border-radius: ${theme.spacing.medium}px;
  pointer-events: auto;
  max-width: ${({ $maxWidth }) => $maxWidth || 'none'};
  height: ${({ $height }) => $height || 'auto'};
  margin: 0 ${theme.spacing.mediumLarge}px;
  @media screen and (min-width: ${theme.breakpoint.medium}px) {
    padding: ${({ $noPadding }) => ($noPadding ? '0' : `${theme.spacing.xxlarge}px`)};
  }
  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    width: 100%;
    height: 100dvh;
    margin: 0;
    border-radius: 0;
    padding: ${({ $noPadding }) => ($noPadding ? '0' : `${theme.spacing.small}px`)};
  }
`
